export default __webpack_public_path__ + "static/media/set7.ebd6afbc.jpeg";